module.exports = "/_next/static/images/shop-726d9a2922a548a535f9dfa6eda18844.svg";